import axios from "axios";
import { isInIframe } from "../utils";
import constants from "@/constants";

export const source = isInIframe() ? "iframe" : "web";

export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

axios.defaults.headers.source = source;

axios.defaults.headers.timezone = timezone;

export const baseURL =
  process.env.REACT_APP_API_URL || "https://turismo-343120.uw.r.appspot.com";

const API = (jwt = "") =>
  axios.create({
    baseURL: `${baseURL}/api`,
    headers: {
      Authorization: jwt ? `Bearer ${jwt}` : undefined,
      "X-Device-UUID": localStorage.getItem(constants.UUID),
    },
  });

export const getErrorMessage = (error) => {
  if (typeof error === "string") {
    return error;
  }
  if (error?.response?.data?.error?.message) {
    return error.response.data.error.message;
  }
  return error.message;
};

const isValidUrl = (url = "") =>
  url.startsWith("http") || url.startsWith("blob");

export const getFileUrl = (url = "") => {
  if (!url) {
    return undefined;
  }
  if (isValidUrl(url)) {
    return url;
  } else {
    return `${baseURL}${url}`;
  }
};

export default API;
